import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  label: {
    paddingBottom: 6,
  },
}));

export default styles;
